import { scenes } from "../scenes";
import { Scene, Choice, Dialog } from "../models";

let facemask = [
  new Dialog(
    "SONNY YANG: Ahh, a surgical - grade PROTECTIVE FACE MASK. I’m sure Dareth Schamren wouldn’t mind if I borrowed this for a tick.",
    require("@/images/sonny.png"),
    require("@/audio/Pandemic-43-Sonny-Revised-MP3.mp3")
  ),
  new Dialog(
    "[Acquired 1 x FACE MASK!]",
    require("@/images/Surgical_Mask.png"),
    require("@/audio/Found_Jingle.mp3")
  ),
];

let spider = [
  new Dialog(
    "VENOMOUS SPIDER creeps out and bites you!",
    require("@/images/Spider.png"),
    require("@/audio/loseitem.mp3")
  ),
];

let spiderWithTongs = [
  new Dialog(
    "[Used SERVING TONGS!]",
    require("@/images/Serving_Tongs.png"),
    require("@/audio/Found_Jingle.mp3")
  ),
  new Dialog(
    "[ACQUIRED 1 X SPARE KEY]",
    require("@/images/Dareths_Spare_Key.png"),
    require("@/audio/Found_Jingle.mp3")
  ),
];

export class DarethsShed extends Scene {
  async init() {
    this.title = "Dareth's Shed";
    this.image = require("@/images/Dareths_Tool_Shed.png");
    this.audio = null;
    this.description = "";
  }

  get options(): any[] {
    return [
      new Choice("Search Cabinet", async () => {
        if (this.state.inventory.facemask.has) {
          this.audio = require("@/audio/Pandemic-44-Sonny-MP3.mp3");

          this.description =
            "SONNY YANG: There’s nothing inside of any significance.";
        } else {
          await this.dialogRunner(facemask)
          this.state.inventory.facemask.has = true;
        }
      }),
      new Choice("Search Ceramic Pots", async () => {
        if (this.state.inventory.key.has) {
          this.audio = require("@/audio/Pandemic-44-Sonny-MP3.mp3");
          this.description =
            "SONNY YANG: There’s nothing inside of any significance.";
        } else if (this.state.inventory.tongs.has) {
          await this.dialogRunner(spiderWithTongs)
          this.state.inventory.key.has = true;
          this.init();
        } else {
          await this.dialogRunner(spider)
          this.state.storylines.bittenBySpider = true;
          await this.navigate(scenes.EmergencyRoom());
        }
      }),
      new Choice("Leave", async () => await this.navigate(scenes.DarethsYard())),
    ];
  }
}

export default new DarethsShed();
